import cx from 'classnames';
import Image from 'next/image';

import { applyDiscount, formatPrice } from '@/src/utils/format/amount';
import { formatVolume } from '@/src/utils/format/volume';
import { IFirestoreOffer } from '@/src/modules/firestore/offers/offers.interface';
import { IFirestorePromo } from '@/src/modules/firestore/promos/promos.interface';
import { formatDuration } from '@/src/utils/format/date';
import { IResolvedDestinationDetailsPlan } from '@/src/utils/pages/destination-details.mapper';
import { ILocaleType } from '@/src/types';

interface IProps {
  offer: IFirestoreOffer;
  promo?: IFirestorePromo;
  isActive: boolean;
  destination?: IResolvedDestinationDetailsPlan;
  onClick(id: string): void;
  locale: ILocaleType;
}

export const DestinationDetailsOffersItem = ({
  offer,
  promo,
  isActive,
  onClick,
  destination,
  locale,
}: IProps) => {
  const discountedPrice = applyDiscount(offer, promo);
  return (
    <button
      className={cx(
        isActive
          ? 'border-primary bg-primary-8'
          : 'border-transparent bg-neutral-100 hover:bg-neutral-200 active:bg-neutral-300',
        'px-8 py-5 border-2 rounded-3xl'
      )}
      onClick={() => onClick(offer.id)}
    >
      <div className={'flex items-start justify-between'}>
        <div className={'space-y-1 text-start'}>
          <p className={'text-2xl font-semibold leading-none'}>
            {formatVolume(discountedPrice.volume)}
            {promo?.type === 'extraData' && (
              <span className={'ml-2 text-lg text-primary line-through'}>
                {formatVolume(offer.volume)}
              </span>
            )}
          </p>
          <p className={'leading-none text-gray'}>
            {destination?.offerDuration &&
              destination.offerDuration.replace(
                '$',
                formatDuration(offer.duration)
              )}
          </p>
          <p className={'text-xl font-semibold leading-none'}>
            {formatPrice(discountedPrice.amount, locale)}
            {(promo?.type === 'percentDiscount' ||
              promo?.type === 'flatDiscount') && (
              <span className={'ml-2 text-lg text-primary line-through'}>
                {formatPrice(offer.basePriceEuros, locale)}
              </span>
            )}
          </p>
        </div>
        {isActive ? (
          <Image
            src={'/static/icons/checkmark-primary.svg'}
            alt={'Offer active'}
            height={24}
            width={24}
          />
        ) : (
          <div
            className={'size-6 rounded-md border border-gray bg-transparent'}
          />
        )}
      </div>
    </button>
  );
};
